import type { MessageRouter } from "./MessageRouter"
import type { ReceiverInput } from "./ReceiverInput"
import type { ReceiverOutput } from "./ReceiverOutput"

export type Implementation<T, R> = (
  stream: ReceiverInput<T>,
  router: MessageRouter<T, R>
) => ReceiverOutput<R>
